import './ComicCard.css';

function ComicCard({ album, onClick })
{
   return (
      <div
         key={ album.id }
         className="album"
         onClick={ () => onClick(album) }
      >
         <img 
            src={ `/images/Blacksad/${album.dossier}/Cover.webp` } 
            alt={ album.titre }
            onError={e=> {
               // e.target.src = 'https://placehold.co/600x400?text=Cover+Not+Found'
               e.target.src = 'https://www.flaggingdirect.com/images/No-Image-Placeholder.png'
            }}
         />
         <h3>{ album.titre }</h3>
         <p>{ album.nbPages } pages</p>
      </div>
   );
}

export default ComicCard;